import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router-dom';

import { useSupplierDetails } from '../../hooks/useSupplierDetails';

import { ErrorState } from './components/ErrorState';
import { LoadingState } from './components/LoadingState';
import { SupplierHeader } from './components/SupplierHeader';
import { SupplierProfileForm } from './SupplierProfileForm';

export const SupplierProfile: React.FC = () => {
  const { supplierId } = useParams<{ supplierId: string }>();

  const { supplier, isLoading, error } = useSupplierDetails({
    id: supplierId ?? '',
  });

  // Redirect if no ID is provided (must be after all hooks)
  if (!supplierId) {
    return <Navigate to="/suppliers" replace />;
  }

  if (isLoading) {
    return <LoadingState />;
  }

  // A distributor that loaded is shown even when one of its fields did not.
  // A distributor with no bot user fails the botUser lookup, and that must not
  // take the whole page down with it.
  if (!supplier) {
    return <ErrorState message={error?.message || 'Distributor not found'} />;
  }

  return (
    <>
      <Helmet>
        <title>
          {supplier.name
            ? `${supplier.name} - Choco Admin`
            : 'Unnamed Distributor - Choco Admin'}
        </title>
      </Helmet>
      <div className="p-6 min-h-screen bg-background">
        <div className="flex flex-col gap-6">
          <SupplierHeader supplier={supplier} />
          <SupplierProfileForm supplier={supplier} />
        </div>
      </div>
    </>
  );
};
